import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import {Outlet} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import MindsetsJsSDK, {LoadMeAction, authUtils, ErrorMessageAction} from "../../index";
import Header from "./Header";
import Footer from "./Footer";
import Loader from "./Loader";
import CustomToast from "../components/CustomToast";

import './layouts.scss';

function FullLayout(
    {
        can_login_to_permission,
        with_footer = true,
        with_loader = true,
        main_menu,
        user_menu
    }
) {
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);

    useEffect(() => {
        if (MindsetsJsSDK().Auth.isAuthenticated()) {
            dispatch(LoadMeAction()).then(user => {
                if (can_login_to_permission && authUtils.iCant(user, [can_login_to_permission])) {
                    dispatch(ErrorMessageAction('You do not have enough permissions to access this application. Please, contact us.'));
                    MindsetsJsSDK().Auth.logout();
                    window.location.href = '/login';
                }
            });
        } else {
            if (location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
    }, []);
    useEffect(() => {
        if (me && !!pusher) {
            const channel = pusher.subscribe('user_' + me.id);
            channel.bind('user.updated', () => dispatch(LoadMeAction()));
            channel.bind('signed_out_' + process.env.PUBLIC_APP_SOURCE, function () {
                MindsetsJsSDK().Auth.logout();
                window.location.href = "/";
            });
            return () => channel.unsubscribe();
        }
    }, [me]);

    function renderFooter() {
        if (with_footer) {
            return <Footer/>;
        }

        return null;
    }

    function renderLoader() {
        if (with_loader) {
            return <Loader/>;
        }

        return null;
    }

    if (me) {
        return (
            <>
                <CustomToast/>
                <Header
                    main_menu={main_menu}
                    user_menu={user_menu}
                />
                <div id="full-layout">
                    <Outlet/>
                </div>
                {renderFooter()}
                {renderLoader()}
            </>
        );
    }

    return (
        <>
            <div>Loading...</div>
        </>
    );
}

FullLayout.propTypes = {
    can_login_to_permission: PropTypes.string,
    with_footer: PropTypes.bool,
    with_loader: PropTypes.bool,
    main_menu: PropTypes.element,
    user_menu: PropTypes.element
};

export default FullLayout;
